import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/recaudacion/inventario-de-placas-tarjetas-de-circulacion/';

/**
 * GET Inventarios Placas Tarjetas Circulacion
 * @returns {Promise<Array<object>>}
 */
export const getInventariosPlacasTarjetasCirculaciones = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET InventarioPlacaTarjetaCirculacion
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getInventarioPlacaTarjetaCirculacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST InventarioPlacaTarjetaCirculacion
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postInventarioPlacaTarjetaCirculacion = async (values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.post(baseURI, formattedValues);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH InventarioPlacaTarjetaCirculacion
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchInventarioPlacaTarjetaCirculacion = async (id, values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.patch(`${baseURI}${id}`, formattedValues);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE InventarioPlacaTarjetaCirculacion
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteInventarioPlacaTarjetaCirculacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
